import { render } from "./LoadModel.vue?vue&type=template&id=fc5c9f84&scoped=true"
import script from "./LoadModel.vue?vue&type=script&lang=js"
export * from "./LoadModel.vue?vue&type=script&lang=js"

import "./LoadModel.vue?vue&type=style&index=0&id=fc5c9f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc5c9f84"]])

export default __exports__